import { render, staticRenderFns } from "./AppText.vue?vue&type=template&id=74c4e9d8&scoped=true"
import script from "./AppText.vue?vue&type=script&lang=js"
export * from "./AppText.vue?vue&type=script&lang=js"
import style0 from "./AppText.vue?vue&type=style&index=0&id=74c4e9d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c4e9d8",
  null
  
)

export default component.exports